import ErrorTooltip from 'Components/ErrorTooltip';
import ToolTip from 'Components/ToolTip';
import { TooltipMsg } from 'Components/ToolTipMessage';
import { Field, FieldProps, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react'
import { Row, Col, Label, Input, Card, CardHeader, CardBody } from 'reactstrap';
import env from "environment_system/env_system";
import { checkValidArray, checkValidObject, errResponse } from 'GenericForms/Helper';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import ReportingFileUpload from 'Components/ReportingFileUpload';
import { getCurrentReportFilesAction } from 'Store/Generic/ReportingSlice';
import PopOver from 'Components/PopOver';
import apiGlobal from 'global/api.global';
import { errorToast, successToast } from 'Components/Toasts';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
import { FileStatus } from 'shared/constants';

interface BillOfLadingProps {
    alertBool: boolean;
    cargoChangePopupBool: boolean;
    editValues?: any,
    setEditValues?: any,
    editReportBool?: boolean,
    editInitialValues?: any,
    setBLFileUpload?: any,
    blFileUpload?: any,
}
const BillOfLading = ({
    alertBool,
    cargoChangePopupBool,
    editValues,
    setEditValues,
    editReportBool,
    setBLFileUpload,
    blFileUpload,
}: BillOfLadingProps) => {
    /** State variables */
    const { discardwarning } = useEditReport();
    const { values, errors, setFieldValue, touched, setValues, setErrors }:
        { values: any, errors: any, handleChange: any, setFieldValue: any, touched: any, setValues: any, setErrors: any } = useFormikContext<any>();
    const { CurrentReport, VesselID, ReportID, CurrentReportFiles } = useSelector((state: RootState) => state.Reporting);
    const billOfLadingCurrentReport = CurrentReport?.data?.deck_officer?.bill_of_lading ?? null;
    const dispatch = useDispatch();
    const [refreshKey, setRefreshKey] = useState<number>(0);
    const billOfLadingFiles = checkValidArray(CurrentReportFiles?.BillOfLading) ? CurrentReportFiles?.BillOfLading[0] : [];
    const [showBOLPopup, setShowBOLPopup] = useState<boolean>(false);
    /** State variables end */

    useEffect(() => {
        if (editValues && editValues?.deck_officer) {
            if (values?.bill_of_lading?.is_bill_of_lading_issued_since_last_report) {
                setEditValues({
                    ...editValues,
                    deck_officer: {
                        ...editValues?.deck_officer,
                        bill_of_lading: {
                            ...values?.bill_of_lading,
                            report_index: null,
                        }
                    }
                })
            } else {
                setEditValues({
                    ...editValues,
                    deck_officer: {
                        ...editValues?.deck_officer,
                        bill_of_lading: {}
                    }
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.bill_of_lading]);

    return (
        <React.Fragment>
            <Row className="mt-3 mb-2">
                <Col sm={3}>
                    <Label
                        className="mb-0"
                        for="is_bill_of_lading_issued_since_last_report"
                    >
                        Is Bill of Lading issued since last report?
                        <i
                            className="bx bx-info-circle ml-2p"
                            id="bill_of_lading_msg"
                        ></i>
                    </Label>
                    <ToolTip
                        target="bill_of_lading_msg"
                        message={`${TooltipMsg.Draft_and_Displacement.filter(
                            (item: any) => item.target === "bill_of_lading_msg"
                        ).map((tool: any) => {
                            return tool.message;
                        })}`}
                    />
                </Col>
                <Col lg={1}>
                    <Field name="bill_of_lading.is_bill_of_lading_issued_since_last_report">
                        {({ field, form }: FieldProps) => (
                            <div className="square-switch sqswitch">
                                <Input
                                    type="checkbox"
                                    switch="none"
                                    name={field.name}
                                    id="is_bill_of_lading_issued_since_last_report"
                                    checked={values?.bill_of_lading?.is_bill_of_lading_issued_since_last_report}
                                    disabled={
                                        editReportBool &&
                                        !checkValidObject(billOfLadingCurrentReport) &&
                                        !billOfLadingCurrentReport?.is_bill_of_lading_issued_since_last_report
                                    }
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        const checked = e.target.checked;
                                        if (!checked) {
                                            if (billOfLadingFiles?.bl_figure_file && !editReportBool) {
                                                setFieldValue(field.name, true);
                                                setShowBOLPopup(true);
                                                return;
                                            }
                                            setFieldValue(field.name, false);
                                            setValues({
                                                ...values,
                                                bill_of_lading: {
                                                    ...values.bill_of_lading,
                                                    is_bill_of_lading_issued_since_last_report: false,
                                                    cargo_survey: false,
                                                    bl_figure: 0,
                                                    ship_figure_of_bl_figure: 0,
                                                    surveyor_figure_of_bl_figure: 0,
                                                    bl_figure_file: null,
                                                    bill_figure_file_path: null,
                                                },
                                            });
                                            setErrors({ ...errors, bill_of_lading: {} });
                                            setBLFileUpload([]);
                                        } else {
                                            setFieldValue(field.name, true);
                                        }
                                    }}
                                />
                                <Label
                                    htmlFor="is_bill_of_lading_issued_since_last_report"
                                    data-on-label="Yes"
                                    data-off-label="No"
                                    className={`mb-0 ${editReportBool &&
                                        !checkValidObject(billOfLadingCurrentReport) &&
                                        !billOfLadingCurrentReport?.is_bill_of_lading_issued_since_last_report &&
                                        "cursor-not-allowed"
                                        }`}
                                />

                                {showBOLPopup && (
                                    <PopOver
                                        target="bill_of_lading_msg"
                                        message={
                                            <p>
                                                Changing <strong>Is Bill of Lading Issued?</strong> to <strong>No</strong> will delete
                                                the uploaded BL file(s) and reset related fields. Do you want to continue?
                                            </p>
                                        }
                                        state={showBOLPopup}
                                        setState={setShowBOLPopup}
                                        handleClick={async () => {
                                            form.setFieldValue('bill_of_lading.is_bill_of_lading_issued_since_last_report', false);
                                            form.setFieldValue('bill_of_lading.cargo_survey', false);
                                            form.setFieldValue('bill_of_lading.bl_figure', 0);
                                            form.setFieldValue('bill_of_lading.ship_figure_of_bl_figure', 0);
                                            form.setFieldValue('bill_of_lading.surveyor_figure_of_bl_figure', 0);
                                            form.setFieldValue('bill_of_lading.bl_figure_file', null);
                                            form.setFieldValue('bill_of_lading.bill_figure_file_path', null);
                                            setBLFileUpload([]);
                                            if (editReportBool) {
                                                setShowBOLPopup(false);
                                                return;
                                            }
                                            const obj = {
                                                is_bill_of_lading_issued_since_last_report: false,
                                                cargo_survey: false,
                                                letter_of_protest: false,
                                                bl_figure: 0,
                                                ship_figure_of_bl_figure: 0,
                                                surveyor_figure_of_bl_figure: 0,
                                                bl_figure_file: null as any,
                                                bill_figure_file_path: null as any,
                                            };
                                            try {
                                                const res = await apiGlobal.patch(`/bill_of_lading/${values?.bill_of_lading?.id}/`, obj);
                                                if (res.status === 200) {
                                                    successToast("Bill of Lading data reset successfully!");
                                                    await dispatch(getCurrentReportFilesAction(ReportID, VesselID));
                                                }
                                            } catch (err: any) {
                                                if (errResponse.includes(err?.response?.status)) {
                                                    errorToast("Internal error occurred, please contact the admin");
                                                }
                                            } finally {
                                                setShowBOLPopup(false);
                                            }
                                        }}
                                    />
                                )}
                            </div>
                        )}
                    </Field>
                </Col>
            </Row>
            {values?.bill_of_lading
                .is_bill_of_lading_issued_since_last_report === true && (
                    <Card className="p-0 mb-0 rounded-0 border-start-0 border-end-0 border-bottom-0">
                        <CardHeader className="p-2">
                            <div className="text-center">
                                <Row>
                                    <Col>
                                        <h4 className="page_title pos-start mb-0">
                                            Bill of Lading
                                        </h4>
                                        <p className="card-title-desc pos-start">
                                            All readings since last report
                                        </p>
                                    </Col>
                                    <Col></Col>
                                </Row>
                            </div>
                        </CardHeader>
                        <CardBody className="px-2 py-0 mt-2">
                            <Row>
                                <Col sm={3}>
                                    <Label className="asteric mb-0" for="bl_figure">
                                        BL figures (Cargo)
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="bl_figure_msg"
                                        ></i>
                                    </Label>
                                    <ToolTip
                                        target="bl_figure_msg"
                                        message={`${TooltipMsg.Draft_and_Displacement.filter(
                                            (item: any) => item.target === "bl_figure_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <div className="mb-3 input-group">
                                        <Field
                                            type="text"
                                            className="form-control text-right max-width-7"
                                            id="bl_figure"
                                            name="bill_of_lading.bl_figure"
                                        />
                                        <div className="input-group-text round_border">
                                            mt
                                        </div>
                                    </div>
                                    {errors?.bill_of_lading &&
                                        touched?.bill_of_lading &&
                                        errors?.bill_of_lading?.bl_figure &&
                                        touched?.bill_of_lading?.bl_figure &&
                                        !alertBool && !cargoChangePopupBool &&
                                        env?.form_validation === true && !discardwarning && (
                                            <ErrorTooltip
                                                target="bl_figure"
                                                message={errors?.bill_of_lading?.bl_figure}
                                                open={
                                                    errors?.bill_of_lading &&
                                                        errors?.bill_of_lading?.bl_figure
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )}
                                </Col>
                                <Col lg={3}>
                                    <Label
                                        className="asteric mb-0"
                                        for="ship_figure_of_bl_figure"
                                    >
                                        Ship figures (Cargo)
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="ship_figure_of_bl_figure_msg"
                                        ></i>
                                    </Label>
                                    <ToolTip
                                        target="ship_figure_of_bl_figure_msg"
                                        message={`${TooltipMsg.Draft_and_Displacement.filter(
                                            (item: any) =>
                                                item.target === "ship_figure_of_bl_figure_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <div className="mb-3 input-group">
                                        <Field
                                            type="text"
                                            className="form-control text-right max-width-7"
                                            id="ship_figure_of_bl_figure"
                                            name="bill_of_lading.ship_figure_of_bl_figure"
                                        />
                                        <div className="input-group-text round_border">
                                            mt
                                        </div>
                                        {errors?.bill_of_lading &&
                                            touched?.bill_of_lading &&
                                            errors?.bill_of_lading
                                                ?.ship_figure_of_bl_figure &&
                                            touched?.bill_of_lading?.ship_figure_of_bl_figure &&
                                            !alertBool && !cargoChangePopupBool &&
                                            env?.form_validation === true && !discardwarning && (
                                                <ErrorTooltip
                                                    target="ship_figure_of_bl_figure"
                                                    message={
                                                        errors?.bill_of_lading
                                                            ?.ship_figure_of_bl_figure
                                                    }
                                                    open={
                                                        errors?.bill_of_lading &&
                                                            errors?.bill_of_lading
                                                                ?.ship_figure_of_bl_figure
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            )}
                                    </div>
                                </Col>
                                {!editReportBool &&
                                    <Col lg={6}>
                                        <ReportingFileUpload
                                            setFile={setBLFileUpload}
                                            file={blFileUpload}
                                            fileURL={billOfLadingFiles?.bl_figure_file}
                                            fileUploadStatus={billOfLadingCurrentReport?.bl_figure_file_status === FileStatus.UPLOADED}
                                            deleteURL={`/bill_of_lading_bl_figure_file/`}
                                            invalidateQuery={null}
                                            deleteID={billOfLadingFiles?.id}
                                            refreshKey={refreshKey}
                                            setRefreshKey={setRefreshKey}
                                            title={'BL Attachment'}
                                            index={0}
                                            sm={5}
                                            CustomAcceptableFileTypes={{
                                                'application/pdf': ['.pdf']
                                            }}
                                        />
                                    </Col>
                                }
                            </Row>
                            <Row>
                                <Col lg={3}>
                                    <div className="d-flex mb-3 gap-2 mt-2">
                                        <Label
                                            className="mb-0 mt-3"
                                            for="cargo_survey"
                                        >
                                            Cargo survey?
                                            <i
                                                className="bx bx-info-circle ml-2p"
                                                id="cargo_survey_msg"
                                            />
                                        </Label>
                                        <ToolTip
                                            target="cargo_survey_msg"
                                            message={`${TooltipMsg.Draft_and_Displacement.filter(
                                                (item: any) =>
                                                    item.target === "cargo_survey_msg"
                                            ).map((tool: any) => {
                                                return tool.message;
                                            })}`}
                                        />
                                        <Field name={"bill_of_lading.cargo_survey"}>
                                            {({ field }: FieldProps) => (
                                                <div className="square-switch sqswitch mt-3">
                                                    <Input
                                                        onFocus={(e) => e.target.select()}
                                                        type="checkbox"
                                                        switch="none"
                                                        name={field.name}
                                                        id="cargo_survey"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                            const checked = e.target.checked;
                                                            setFieldValue(field.name, checked);
                                                            if (!checked) {
                                                                setFieldValue("bill_of_lading.surveyor_figure_of_bl_figure", 0);
                                                            }
                                                        }}
                                                        checked={
                                                            values?.bill_of_lading.cargo_survey
                                                        }
                                                    />
                                                    <Label
                                                        htmlFor="cargo_survey"
                                                        data-on-label="Yes"
                                                        data-off-label="No"
                                                    ></Label>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                </Col>
                                {values?.bill_of_lading.cargo_survey && (
                                    <>
                                        <Col lg={3}>
                                            <Label
                                                className="asteric mb-0"
                                                for="surveyor_figure_of_bl_figure"
                                            >
                                                Surveyor figures (Cargo)
                                                <i
                                                    className="bx bx-info-circle ml-2p"
                                                    id="surveyor_figure_of_bl_figure_msg"
                                                ></i>
                                            </Label>
                                            <ToolTip
                                                target="surveyor_figure_of_bl_figure_msg"
                                                message={`${TooltipMsg.Draft_and_Displacement.filter(
                                                    (item: any) =>
                                                        item.target ===
                                                        "surveyor_figure_of_bl_figure_msg"
                                                ).map((tool: any) => {
                                                    return tool.message;
                                                })}`}
                                            />
                                            <div className="input-group">
                                                <Field
                                                    type="text"
                                                    className="form-control text-right max-width-7"
                                                    id="surveyor_figure_of_bl_figure"
                                                    name="bill_of_lading.surveyor_figure_of_bl_figure"
                                                />
                                                <div className="input-group-text round_border">
                                                    mt
                                                </div>
                                                {errors?.bill_of_lading &&
                                                    touched?.bill_of_lading &&
                                                    errors?.bill_of_lading
                                                        ?.surveyor_figure_of_bl_figure &&
                                                    touched?.bill_of_lading?.surveyor_figure_of_bl_figure &&
                                                    !alertBool && !cargoChangePopupBool &&
                                                    env?.form_validation === true && !discardwarning && (
                                                        <ErrorTooltip
                                                            target="surveyor_figure_of_bl_figure"
                                                            message={
                                                                errors?.bill_of_lading
                                                                    ?.surveyor_figure_of_bl_figure
                                                            }
                                                            open={
                                                                errors?.bill_of_lading &&
                                                                    errors?.bill_of_lading
                                                                        ?.surveyor_figure_of_bl_figure
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                    )}
                                            </div>
                                        </Col>
                                        {/* <Col lg={3}>
                                                        <Label for="survey_attachment" className="mt-3 mb-0">Surveyor figure attachment
                                                            <i className='bx bx-info-circle ml-2p' id='survey_attachment_msg' />
                                                            <i className="ml-1 dripicons-upload icon_s23 mt-3"
                                                                onClick={() => {
                                                                    setSurveyAttachmentBool(true);
                                                                }}
                                                                data-toggle="modal"
                                                                id='survey_attachment'></i>
                                                        </Label>
                                                        {(BillOfLadingObject?.length > 0 && BillOfLadingObject[0]?.id > 0) ?
                                                            <Label className='mt-0 primary-label'>{values?.bill_of_lading.survey_attachment}</Label> : null
                                                        }
                                                        <ToolTip target='survey_attachment_msg'
                                                            message={`${TooltipMsg.Draft_and_Displacement
                                                                .filter((item: any) => item.target === 'survey_attachment_msg')
                                                                .map((tool: any) => { return tool.message })}`}
                                                        />
                                                    </Col>
                                                    <ReportingFileUploadModal
                                                        state={surveyAttachmentBool}
                                                        array={surveyAttachment}
                                                        setArray={setSurveyAttachment}
                                                        modalId={'survey_attachment'}
                                                    /> */}
                                    </>
                                )}
                            </Row>
                            {/* <Row>
                                            <Col lg={3}>
                                                <div className="d-flex flex-wrap gap-2 mb-3">
                                                    <Label className="mt-3 w-10">
                                                        Letter of protest?<i className='bx bx-info-circle ml-2p' id='letter_of_protest_msg'></i>
                                                    </Label>
                                                    <ToolTip target='letter_of_protest_msg'
                                                        message={`${TooltipMsg.Draft_and_Displacement.filter((item: any) => item.target === 'letter_of_protest_msg')
                                                            .map((tool: any) => { return tool.message })}`}
                                                    />
                                                    <Field name={'bill_of_lading.letter_of_protest'}>
                                                        {({ field, form }: FieldProps) => (
                                                            <div className="square-switch sqswitch mt-3">
                                                                <Input
onFocus={(e) => e.target.select()}
                                                                    type="checkbox"
                                                                    switch="none"
                                                                    name={field.name}
                                                                    id="letter_of_protest"
                                                                    onChange={handleChange}
                                                                    defaultChecked={values?.bill_of_lading.letter_of_protest}
                                                                />
                                                                <Label
                                                                    htmlFor="letter_of_protest"
                                                                    data-on-label='Yes'
                                                                    data-off-label='No'>
                                                                </Label>
                                                            </div>
                                                        )}
                                                    </Field>
                                                </div>
                                            </Col>
                                            {values?.bill_of_lading.letter_of_protest &&
                                                <>
                                                    <Col lg={3}>
                                                        <Label for="letter_of_protest_attachment" className="mt-2">Letter of protest attachment
                                                            <i className='bx bx-info-circle ml-2p' id='letter_of_protest_attachment_msg' />
                                                            <i className="ml-1 dripicons-upload icon_s23 mt-2"
                                                                onClick={() => {
                                                                    setLetterofProtestAttachmentBool(true);
                                                                }}
                                                                data-toggle="modal"
                                                                id='letter_of_protest_attachment' />
                                                        </Label>
                                                        {(BillOfLadingObject?.length > 0 && BillOfLadingObject[0]?.id > 0) ?
                                                            <Label className='mt-0 primary-label'>{values?.bill_of_lading.letter_of_protest_attachment}</Label> : null
                                                        }
                                                        <ToolTip target='letter_of_protest_attachment_msg'
                                                            message={`${TooltipMsg.Draft_and_Displacement
                                                                .filter((item: any) => item.target === 'letter_of_protest_attachment_msg')
                                                                .map((tool: any) => { return tool.message })}`}
                                                        />
                                                    </Col>
                                                    <ReportingFileUploadModal
                                                        state={letterofProtestAttachmentBool}
                                                        array={letterofProtestAttachment}
                                                        setArray={setLetterofProtestAttachment}
                                                        modalId={'letter_of_protest_attachment'}
                                                    />
                                                </>
                                            }
                                        </Row> */}
                        </CardBody>
                    </Card>
                )}
        </React.Fragment>
    )
}

export default BillOfLading